import { useId } from "react";

type CheckboxChipProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
};

/** Checkbox dạng chip — dark theme (.checkbox-chip trong styles.css) */
export function CheckboxChip({ checked, onChange, label, disabled = false }: CheckboxChipProps) {
  const id = useId();
  return (
    <label
      htmlFor={id}
      className={`checkbox-chip${checked ? " is-checked" : ""}`}
      style={disabled ? { opacity: 0.55, pointerEvents: "none" } : undefined}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="checkbox-chip__box" aria-hidden="true">
        <span className="material-symbols-outlined">check</span>
      </span>
      {label}
    </label>
  );
}
